import { useEffect, useState } from 'react';
import { OrgBase } from '../../../common/src/model.ts';
import * as server_api from '../../../common/src/server_api.ts';

export function useAllOrgs(): { orgs: OrgBase[]; isLoading: boolean } {
  const [orgs, setOrgs] = useState<OrgBase[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    void (async () => {
      try {
        setOrgs(await server_api.getAllOrgs());
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return { orgs, isLoading };
}
